import { render, staticRenderFns } from "./TutorialsPage.vue?vue&type=template&id=e23cc248"
import script from "./TutorialsPage.vue?vue&type=script&lang=js"
export * from "./TutorialsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports